/**
 * Отслеживает каждое появление в DOM элемента, соответствующего селектору, и вызывает callback.
 *
 * @param {string} selector - CSS-селектор элемента, за которым нужно следить.
 * @param {(el: Element) => void} callback - Функция, вызываемая каждый раз при добавлении элемента.
 */
export const onElementAdded = (selector, callback) => {
    const observer = new MutationObserver((mutations) =>
        mutations.forEach((mutation) =>
            mutation.addedNodes.forEach((node) => {
                // Проверяем, что узел является элементом (nodeType === 1)
                if (node.nodeType === 1) {
                    const element = /** @type {Element} */ (node);

                    // Если сам узел соответствует селектору — вызываем callback
                    if (element.matches(selector)) {
                        callback(element);
                    }

                    // Если нужные элементы находятся внутри этого узла — вызываем callback для каждого
                    element.querySelectorAll?.(selector)?.forEach?.((el) => callback(el));
                }
            }),
        ),
    );

    // Начинаем наблюдение за всем телом документа
    observer.observe(document.body, {
        childList: true, // Следим за добавлением/удалением детей
        subtree: true, // Следим за всеми уровнями вложенности
    });
};
